const API_PATH = "https://api.vancouver-live.fr/api/";

export default API_PATH;